import api from "./api";
import { IOrder } from 'config/interfaces';

const getAll = (values?: IOrder.Params) => {
  const params = values ? { ...values } : { };
 
  return api.patch<IOrder.Order[]>("/api_front/TransactionSearch", params);
}

interface UpdateStatusProps {
  idtransacao: number,
  command: number
}

// TODO - NAO ESTA ACEITANDO ARRAY
const updateStatus = (values: UpdateStatusProps) => {
  return api.post("/api_front/pendingTransaction", values);
}

export { getAll, updateStatus }